import { useState } from 'react';
import { localeRepository } from '../i18n/repository';
import { useLocale } from '../i18n/react';
import { languageHref, readBrowserRoute } from '../routing/browser';

/** Offer English at the VI entry point without redirecting users or crawlers. */
export function LanguageSuggestion() {
  const locale = useLocale();
  const [offered] = useState(() => {
    const route = readBrowserRoute();
    return !route.notFound && route.view === 'discover' && locale === 'vi' && localeRepository.suggested() === 'en';
  });
  const [dismissed, setDismissed] = useState(false);
  if (!offered || dismissed || locale !== 'vi' || readBrowserRoute().view !== 'discover') return null;
  return <aside className="language-suggestion" aria-label="Language suggestion" lang="en">
    <p>Prefer English? DesignForge is available in English.</p>
    <div>
      <a href={languageHref('en')} hrefLang="en" onClick={() => { localeRepository.write('en'); setDismissed(true); }}>Continue in English</a>
      <button type="button" lang="vi" onClick={() => { localeRepository.write('vi'); setDismissed(true); }}>Tiếp tục tiếng Việt</button>
    </div>
  </aside>;
}
